<mat-card>
  <mat-card-content>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <h2>Bejelentkezés</h2>
      <mat-error *ngIf="loginInvalid">
        Nem helyes a felhasználónév, vagy a jelszó
      </mat-error>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Felhasználónév" formControlName="username" required>
        <mat-error>
          Add meg a felhasználóneved
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput type="password" placeholder="Jelszó" formControlName="password" required>
        <mat-error>
          Add meg a jelszavad
        </mat-error>
      </mat-form-field>
      <button mat-raised-button color="primary">Belépés</button>
    </form>
  </mat-card-content>
</mat-card>
